var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 17.5C14.1426 17.5 17.5005 14.1421 17.5005 10C17.5005 5.85786 14.1426 2.5 10.0005 2.5C5.85835 2.5 2.50049 5.85786 2.50049 10C2.50049 14.1421 5.85835 17.5 10.0005 17.5ZM10.6701 7.32143C10.6701 6.95159 10.3703 6.65179 10.0005 6.65179C9.63065 6.65179 9.33085 6.95159 9.33085 7.32143V10C9.33085 10.1567 9.38577 10.3083 9.48605 10.4287L12.1646 13.643C12.4014 13.9271 12.8236 13.9655 13.1078 13.7287C13.3919 13.492 13.4303 13.0697 13.1935 12.7856L10.6701 9.75756V7.32143Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9670450d73e04737c6ec9c9108b958d0.svg";
export { ForwardRef as ReactComponent };